const useBrowserExt = () => {
  const path = window.location.pathname;
  if (path.includes("browser-ext")) {
    return { isBrowserExt: true };
  }
  return { isBrowserExt: false };
};

export default useBrowserExt;
